export default __webpack_public_path__ + "static/media/home.8079dfcf.png";